import { Provider } from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

/**
 * Sinds CDK 21 zet de CDK overlays standaard in de top layer van de browser (popover-API).
 * Daar telt z-index niet, alleen de volgorde van openen, en ligt alles daarbuiten eronder.
 * De app stapelt via z-index: zwevende panelen en dialogen (FloatingPanelService),
 * toasts, ng-select-dropdowns met appendTo="body" in dialogen en ngx-popovers.
 * Daarom blijven overlays in de gewone overlay-container.
 */
export const OVERLAY_STACKING_PROVIDER: Provider = {
  provide: OVERLAY_DEFAULT_CONFIG,
  useValue: { usePopover: false }
};
